import React, {FC} from 'react';
import styled from 'styled-components';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {useAppSelector} from '../../../helpers/reduxHelpers';
import {TeamModel} from '../../../models/api/teamModel';
import {getIsUserGlobalAdmin, getUser} from '../../../store/data/teammates/teammatesSelectors';
import {AnalyticsNamespaceDropdownBox} from './analyticsNamespaceDropdownBox';

/*
 * Props.
 */

interface ReportNavigationNamespaceDropdownProps {
  teams: ReadonlyArray<TeamModel>;
  selectedNamespace: string;
  onSelectedNamespaceChange: HandlerOf<string>;
}

/*
 * Styles.
 */

const NamespaceDropdownBoxWrapper = styled.div`
  padding: 0 16px 8px;
`;

/*
 * Component.
 */

export const ReportNavigationNamespaceDropdown: FC<ReportNavigationNamespaceDropdownProps> = ({
  teams,
  selectedNamespace,
  onSelectedNamespaceChange,
}) => {
  const theme = useUserTheme();
  const user = useAppSelector(getUser);
  const isUserGlobalAdmin = useAppSelector(getIsUserGlobalAdmin);

  const doesCompanyHaveMultipleTeams = teams.length > 1;

  // If a company only has a single team we just render that teams namespace in the dropdown
  // rather than the company level view (since these would show the same data with only one team)
  const shouldIncludeCompanyDropdownItem = doesCompanyHaveMultipleTeams && isUserGlobalAdmin;

  return (
    <NamespaceDropdownBoxWrapper>
      <AnalyticsNamespaceDropdownBox
        teams={teams}
        userNamespace={user.namespace}
        selectedNamespace={selectedNamespace}
        onNamespaceSelect={onSelectedNamespaceChange}
        backgroundColor={theme.foreground}
        shouldIncludeCompanyDropdownItem={shouldIncludeCompanyDropdownItem}
      />
    </NamespaceDropdownBoxWrapper>
  );
};
